import styles from './Footer.module.scss';
import motusLogo from '../../../assets/images/logoMotus.png';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import Downloads from '../../custom/Downloads/Downloads';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [jestOtwarte, ustawNaOtwarte] = useState(false);

  return (
    <div className={styles.footer}>
      <div className={styles.box}>
        {/* 1. Logo + desc */}
        <div className={styles.column}>
          <img src={motusLogo} alt='logo' className={styles.logo} />
          <p>
            Centrum Rozwoju i Terapii MOTUS s.c. <br />
            Anna Paluch Jarosław Słoma
          </p>
        </div>

        {/* 2. navigation */}
        <div className={styles.column}>
          <h3>Nawigacja</h3>
          <ul>
            <li>
              <Link className={styles.hoverItem} to='/'>
                Strona główna
              </Link>
            </li>
            <li>
              <Link className={styles.hoverItem} to='/offers'>
                Oferta
              </Link>
            </li>
            <li>
              <Link className={styles.hoverItem} to='/aboutUs'>
                O nas
              </Link>
            </li>
            <li>
              <Link className={styles.hoverItem} to='/team'>
                Zespół
              </Link>
            </li>
            <li>
              <Link className={styles.hoverItem} to='/priceList'>
                Cennik
              </Link>
            </li>
            <li>
              <Link className={styles.hoverItem} to='/contact'>
                Kontakt
              </Link>
            </li>
          </ul>
        </div>

        {/* 3. info */}
        <div className={styles.column}>
          <h3>Informacje</h3>
          <ul>
            <li>
              <button
                className={styles.hoverItem}
                onClick={(event) => {
                  event.preventDefault();
                  ustawNaOtwarte(true);
                }}
              >
                Pliki do pobrania
              </button>
            </li>

            <li>
              <Link className={styles.hoverItem} to='/articles'>
                Artykuły
              </Link>
            </li>
          </ul>

          {jestOtwarte && <Downloads onClose={() => ustawNaOtwarte(false)} />}
        </div>

        {/* 4. contact */}
        <div className={styles.column}>
          <h3>Kontakt</h3>
          <ul>
            <li>
              <a className={styles.hoverItem} href='tel:+48668700455'>
                tel: 668 700 455
              </a>
            </li>

            <li>
              <a
                className={styles.hoverItem}
                href='mailto:centrumrozwojumotus@gmail.com'
              >
                E-mail: centrumrozwojumotus@gmail.com
              </a>
            </li>

            <li>
              <a
                className={styles.hoverItem}
                href='https://www.google.com/maps?q=Centrum+Rozwoju+i+Terapii+Motus+Niepołomice'
                target='_blank'
                rel='noopener noreferrer'
              >
                Adres: ul. Targowa 6D, Niepołomice
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* last info*/}
      <div className={styles.bottom}>
        <p>
          © {currentYear} Centrum Rozwoju i Terapii Motus s.c. Anna Paluch
          Jarosław Słoma
        </p>
        <p>
          <a
            className={styles.hoverItem}
            href='https://www.linkedin.com/in/damian-faron/'
            target='_blank'
            rel='noopener noreferrer'
          >
            Damian Faron
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
